import { connect as m, socketObservable as N } from "../main.js";
import "../connection.js";
import { f as d, t as y, m as C, c as U, a as W, b as q, d as b, p as f, e as p, g as k, w as v, h as E, i as I, R as M, j as O, k as T, l as x } from "../helpers-BowLJ2Uh.js";
import { actions as S } from "./reducer.js";
import { getWebsocket as B } from "./selectors.js";
var w = function(t) {
  return {
    done: !0,
    value: t
  };
}, h = {};
function A(e) {
  return U(e) ? "channel" : W(e) ? String(e) : q(e) ? e.name : String(e);
}
function R(e, t, n) {
  var o, s, i, c = t;
  function a(u, r) {
    if (c === h)
      return w(u);
    if (r && !s)
      throw c = h, r;
    o && o(u);
    var l = r ? e[s](r) : e[c]();
    return c = l.nextState, i = l.effect, o = l.stateUpdater, s = l.errorState, c === h ? w(u) : i;
  }
  return C(a, function(u) {
    return a(null, u);
  }, n);
}
function J(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    o[s - 2] = arguments[s];
  var i = {
    done: !1,
    value: y(e)
  }, c = function(l) {
    return {
      done: !1,
      value: d.apply(void 0, [t].concat(o, [l]))
    };
  }, a, u = function(l) {
    return a = l;
  };
  return R({
    q1: function() {
      return {
        nextState: "q2",
        effect: i,
        stateUpdater: u
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: c(a)
      };
    }
  }, "q1", "takeEvery(" + A(e) + ", " + t.name + ")");
}
function g(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    o[s - 2] = arguments[s];
  return d.apply(void 0, [J, e, t].concat(o));
}
function* K(e) {
  try {
    (yield T(B)).connected || (yield y(["CONNECTION_SUCCESS"]));
    let n = e.payload?.key;
    const o = e.payload?.handler;
    if (n = JSON.parse(n), !n)
      throw new Error("No key passed through to subscribe to");
    const s = {
      action: "subscribe",
      ...n
    };
    yield f(
      S.send({
        ...s
      })
    );
    const i = N(s);
    if (i === void 0) {
      console.log("failed to register websocket");
      return;
    }
    const c = yield b(x, i, o);
    try {
      for (; ; ) {
        const a = yield y(c);
        yield f(a);
      }
    } finally {
      c.close();
    }
  } catch (t) {
    console.log("Error: failed to register websocket", t);
  }
}
function* F(e) {
  try {
    const t = e.payload?.key;
    if (!t)
      throw new Error("No key passed through to subscribe to!");
    const o = {
      action: "unsubscribe",
      ...JSON.parse(t)
    };
    yield f(
      S.send({
        ...o
      })
    );
  } catch {
    console.log("Unable to unsubscribe", JSON.stringify(e));
  }
}
function* j() {
  yield g("SUBSCRIBE_TO_WEBSOCKET", K);
}
function* H() {
  yield g("UNSUBSCRIBE_FROM_WEBSOCKET", F);
}
function* $() {
  yield g("CONNECTION_SUCCESS", O);
}
function z(e, t, n) {
  return function* () {
    n && (yield y(n)), yield k([d(j)]), yield k([d(H)]), yield k([d($)]);
    const s = yield m(e, t), i = yield b(v, s.ws), c = yield d(E, s.ws);
    yield f(S.connectionSuccess());
    try {
      for (; ; ) {
        const a = yield y(i);
        yield f(a);
      }
    } finally {
      return i.close(), yield p(c), yield I(M), yield b(z, e, t, n);
    }
  };
}
function* V() {
  const e = new WebSocket("ws://localhost:8080"), t = yield b(v, e);
  yield f(S.connectionSuccess());
  const n = yield d(E, e);
  try {
    for (; ; ) {
      const o = yield y(t);
      yield f(o);
    }
  } finally {
    t.close(), yield p(n), e.close();
  }
}
export {
  V as default,
  z as getMainSaga
};
